import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useDownloadSnapshotAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterBody, params, page_number, page_size) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios.post(
          `${INVENTORY_MODULE?.PRODUCT_FILTER?.baseURL}?selected_tab=${params}&page_number=${page_number}&page_size=${page_size}&convert_to_csv=1`,
          filterBody,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
            responseType: "blob",
          },
        );
        if (response && response.headers["content-type"] === "text/csv") {
          const csvContent = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
          const url = window.URL.createObjectURL(csvContent);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "inventory_data.csv");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success("CSV Export Successful");
        } else {
          toast.error("CSV Export Failed: No content received");
        }
      } catch (e) {
        sendCurl(e.config["curlCommand"]);
        toast.error("Server Error: " + e.message);
      }
    },
    [configuration, sendCurl],
  );

  return { execute };
};
